import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import HImage from "../../../../../form/src/common/components/image.vue";
let ImageDesign = class ImageDesign extends Vue {
    render(h) {
        const that = this;
        return h('h-image', { props: {
                disabled: true,
                text: that.$t('cloudpivot.form.dataitem.ClickOrDragUpload').toString(),
            } });
    }
};
tslib_1.__decorate([
    Prop()
], ImageDesign.prototype, "control", void 0);
ImageDesign = tslib_1.__decorate([
    Component({ name: 'ImageDesign', components: { HImage } })
], ImageDesign);
export default ImageDesign;
